(() => {
  const menus = () => document.querySelectorAll('header-menu > details.mega-menu[open]');
  const close = (details, restoreFocus = false) => {
    const disclosure = details.closest('header-menu');
    if (typeof disclosure?.close === 'function') disclosure.close();
    else {
      details.open = false;
      details.querySelector('summary').setAttribute('aria-expanded', 'false');
    }
    details.querySelectorAll('localization-form').forEach(form => form.hidePanel?.());
    if (restoreFocus) details.querySelector('summary').focus();
  };
  // Close the mobile navigation before the search dialog installs its focus trap.
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element) || !event.target.closest('details-modal.header__search summary')) return;
    document.querySelectorAll('header-drawer').forEach(drawer => {
      if (drawer.mainDetailsToggle?.open) {
        drawer.closeMenuDrawer(event, drawer.mainDetailsToggle.querySelector('summary'));
      }
    });
  }, true);
  document.addEventListener('click', event => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const button = target.closest('[data-auren-menu-close]');
    if (button) {
      close(button.closest('details.mega-menu'), true);
      return;
    }
    if (!target.closest('.header__inline-menu')) menus().forEach(details => close(details));
  });
  document.addEventListener('toggle', event => {
    if (!(event.target instanceof HTMLDetailsElement) || !event.target.matches('header-menu > details.mega-menu') || !event.target.open) return;
    menus().forEach(details => { if (details !== event.target) close(details); });
  }, true);
  document.addEventListener('open', event => {
    if (event.target instanceof Element && event.target.matches('shopify-account')) menus().forEach(details => close(details));
  }, true);
  window.matchMedia('(min-width: 990px)').addEventListener('change', event => {
    if (!event.matches) menus().forEach(details => close(details));
  });
})();
